export const clientVersion = 11



// WEBPACK FOOTER //
// ./src/utils/env.js